import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "generate-catalog-selection-container"
}
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "font-weight-bold mb-1" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-6" }
const _hoisted_6 = { class: "menubar-left-item-wrapper" }
const _hoisted_7 = { class: "font-weight-bold mb-1" }
const _hoisted_8 = { class: "catalog-table-wrapper" }
const _hoisted_9 = { class: "table table-borderless catalog-table with-sticky-header" }
const _hoisted_10 = { class: "header-border" }
const _hoisted_11 = { class: "name-column" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 1,
  class: "spinner-container"
}

import { reactive, computed, onMounted, watch } from "vue";
import { useI18n } from "vue-i18n";
import { ChannelCreatorState } from "@medapro-types/ChannelCreator/store/channel-creator-store";
import { createNamespacedHelpers } from "vuex-composition-helpers";
import MenuBar from "@common/components/MenuBar/MenuBar.vue";
import commonFilter from "@common/components/CommonFilter.vue";
import _ from "lodash";
import { useContentLanguages } from "@common/composable/useMetaDataStore";

//#region General
type ViewModel = {
  loading: boolean;
  localTargetCatalogName: string | null;
  localSourceCatalogId: string | null;
  filterText: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'CatalogSelection',
  props: {
    sourceCatalogId: {},
    targetCatalogName: {}
  },
  emits: ["update:sourceCatalogId", "update:targetCatalogName"],
  setup(__props: any, { expose: __expose, emit: emits }) {

const props = __props;



const { t: $t, d: $d } = useI18n();
//#endregion

//#region Store
const { primaryLanguageCode } = useContentLanguages();

const { useState: useChannelCreatorState } = createNamespacedHelpers<ChannelCreatorState>("channelCreator");
const { catalogs } = useChannelCreatorState(["catalogs"]);
//#endregion

//#region ViewModel

const vm = reactive<ViewModel>({
  loading: false,
  localTargetCatalogName: "",
  localSourceCatalogId: "",
  filterText: ""
});

const state = reactive({
  isValid: true
});
//#endregion

//#region validation
const validationFeedbacks = computed(() => {
  const isNameEmpty = vm.localTargetCatalogName == "" || vm.localTargetCatalogName == null;
  const isDuplicateNameExists =
    vm.localTargetCatalogName &&
    _.filter(
      catalogs.value,
      (x) =>
        x &&
        x[primaryLanguageCode.value] &&
        x[primaryLanguageCode.value].name &&
        x[primaryLanguageCode.value]?.name.toLowerCase() == vm.localTargetCatalogName?.toLowerCase()
    ).length > 0;
  const isNameLengthExceeds = (vm.localTargetCatalogName ?? "").length > 256;

  if (isNameEmpty) return $t("validation.valueRequired", { field: $t("name") });
  else if (isDuplicateNameExists)
    return $t("validation.duplicateExists", {
      field: $t("name")
    });
  else if (isNameLengthExceeds)
    return $t("validation.lengthExceeds", {
      field: $t("name", 1),
      length: 128
    });
  else return null;
});
//#endregion

const filteredCatalogs = computed(() =>
  !vm.filterText
    ? catalogs.value
    : _.filter(
        catalogs.value,
        (x) => x && x[primaryLanguageCode.value]?.name && x[primaryLanguageCode.value]?.name.toLowerCase().indexOf(vm.filterText.toLowerCase()) >= 0
      )
);

//#region LifeCycle
onMounted(() => {
  vm.localTargetCatalogName = props.targetCatalogName;
  vm.localSourceCatalogId = props.sourceCatalogId;
  vm.filterText = "";
});

//#endregion

//#region watch
watch(
  () => vm.localSourceCatalogId,
  (nv) => {
    emits("update:sourceCatalogId", nv);
  },
  { deep: true }
);
watch(
  () => vm.localTargetCatalogName,
  (nv) => {
    emits("update:targetCatalogName", nv);
  },
  { deep: true }
);

watch(
  () => validationFeedbacks.value,
  (nv) => {
    if (nv) {
      state.isValid = false;
    } else {
      state.isValid = true;
    }
  },
  { deep: true }
);
//#endregion

//#region Exposed

__expose({ state });

//#endregion

return (_ctx: any,_cache: any) => {
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_Spinner = _resolveComponent("Spinner")!

  return (!vm.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref($t)("newCatalogName")), 1),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_b_form_input, {
                modelValue: vm.localTargetCatalogName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((vm.localTargetCatalogName) = $event)),
                id: "targetCatalogNameInput",
                class: _normalizeClass({ 'border-danger': validationFeedbacks.value })
              }, null, 8, ["modelValue", "class"])
            ])
          ])
        ]),
        _createVNode(MenuBar, { withoutBorder: "" }, {
          leftItems: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(_unref($t)("Catalogs")), 1),
              _createElementVNode("span", null, _toDisplayString(_unref($t)("catalogSelectionTitle")), 1)
            ])
          ]),
          rightItems: _withCtx(() => [
            _createVNode(commonFilter, {
              modelValue: vm.filterText,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((vm.filterText) = $event)),
              placeholder: _unref($t)('Filter')
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("table", _hoisted_9, [
            _createElementVNode("thead", _hoisted_10, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", _hoisted_11, _toDisplayString(_unref($t)("name")), 1),
                _createElementVNode("th", null, _toDisplayString(_unref($t)("Articles")), 1),
                _createElementVNode("th", null, _toDisplayString(_unref($t)("VariantGroups")), 1),
                _createElementVNode("th", null, _toDisplayString(_unref($t)("CatalogGroups")), 1),
                _createElementVNode("th", null, _toDisplayString(_unref($t)("UpdatedOn")), 1),
                _createElementVNode("th", null, _toDisplayString(_unref($t)("UpdatedBy")), 1),
                _createElementVNode("th", null, _toDisplayString(_unref($t)("CreatedOn")), 1),
                _createElementVNode("th", null, _toDisplayString(_unref($t)("CreatedBy")), 1)
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredCatalogs.value, (catalog) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: catalog[_unref(primaryLanguageCode)].catalogId,
                  onClick: ($event: any) => (vm.localSourceCatalogId = catalog[_unref(primaryLanguageCode)]?.catalogId),
                  class: _normalizeClass({ selected: vm.localSourceCatalogId === catalog[_unref(primaryLanguageCode)].catalogId })
                }, [
                  _createElementVNode("td", {
                    class: _normalizeClass({
                'selection-indicator-box': vm.localSourceCatalogId === catalog[_unref(primaryLanguageCode)].catalogId,
                'non-selection-indicator-box': vm.localSourceCatalogId !== catalog[_unref(primaryLanguageCode)].catalogId
              })
                  }, _toDisplayString(catalog[_unref(primaryLanguageCode)].name), 3),
                  _createElementVNode("td", null, _toDisplayString(catalog[_unref(primaryLanguageCode)].catalogArticles), 1),
                  _createElementVNode("td", null, _toDisplayString(catalog[_unref(primaryLanguageCode)].variationGroups), 1),
                  _createElementVNode("td", null, _toDisplayString(catalog[_unref(primaryLanguageCode)].catalogGroups), 1),
                  _createElementVNode("td", null, _toDisplayString(_unref($d)(catalog[_unref(primaryLanguageCode)].updatedOn, "shortDateTime")), 1),
                  _createElementVNode("td", null, _toDisplayString(catalog[_unref(primaryLanguageCode)].updatedBy), 1),
                  _createElementVNode("td", null, _toDisplayString(_unref($d)(catalog[_unref(primaryLanguageCode)].createdOn, "shortDateTime")), 1),
                  _createElementVNode("td", null, _toDisplayString(catalog[_unref(primaryLanguageCode)].createdBy), 1)
                ], 10, _hoisted_12))
              }), 128))
            ])
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_13, [
        _createVNode(_component_Spinner)
      ]))
}
}

})